module.exports = __webpack_public_path__ + "img/m2g_event_btn.709ab36c.png";